<app-auth-layout
  pageTitle="Forgot Password?"
  subtitle="Remembered your password?"
  actionLinkText="Log in"
  actionLinkRoute="/login"
>
  <p class="text-gray-500 text-sm mb-8 leading-relaxed">
    Enter your email address below and we'll send you a secure link to reset
    your password.
  </p>

  <form [formGroup]="forgotForm" (ngSubmit)="submit()" class="space-y-5">
    <div class="flex flex-col gap-1.5">
      <label for="email" class="text-sm font-semibold text-gray-700 ml-1"
        >Email Address</label
      >
      <input
        pInputText
        id="email"
        type="email"
        formControlName="email"
        class="w-full h-11 px-4 !bg-gray-50 border border-gray-200 focus:!bg-white focus:!border-[--primary-500] focus:ring-4 focus:ring-[--primary-100] outline-none text-sm transition-all rounded-lg"
        placeholder="Enter your email"
      />
      <small
        class="text-red-500 text-xs ml-1"
        *ngIf="
          forgotForm.get('email').touched && forgotForm.get('email').invalid
        "
      >
        Valid email is required
      </small>
    </div>

    <button
      pButton
      type="submit"
      label="Send Reset Link"
      class="w-full h-11 font-bold text-base bg-[--primary-500] text-white border-none hover:bg-[--primary-600] active:scale-[0.98] transition-all rounded-lg shadow-lg shadow-blue-500/20 mt-2"
      [disabled]="!forgotForm.valid"
    ></button>
  </form>
</app-auth-layout>
